
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";

import ConsultaPergunta from '../../../../../lib/json/consultas/Perguntas.json'
import ConsultaEtapas from '../../../../../lib/json/consultas/Etapas.json'
import ConsultaFormularioCRM from '../../../../../lib/json/consultas/FormularioCRM.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import { ConsultaAPI } from "../../../../../backend/ConsultaAPI";
import SubmitForm from "../../../../components/SubmitForm";
import { ConsumoAPI_POST, ConsumoAPI_PUT } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import SelectFixo from "../../../../components/SelectFixo";
import { CancelarButton } from "../../../../components/SubmitForm/styles";
import ResponsiveDataTable from "../../../../components/DataTable";
import SelectDinamico from "../../../../components/SelectDinamico";
import { HRDivider } from "./styles";

function handleSimNao(item){
    return item.value == 'S' ? "SIM" : "NÃO"
}

function FichaEtapa(){
    const navigate = useNavigate();
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const { idEtapa } = useParams();

    // Consulta do grid
    var consultaEtapa  = ConsultaEtapas.consulta + (idEtapa ? ` WHERE Id = '${idEtapa}' ` : '');
    var consultaFormulario  = ConsultaFormularioCRM.consulta + (idEtapa ? ` WHERE EtapasId = '${idEtapa}' AND CategoriasId IS NULL ORDER BY Ordem` : '');

    var [campoIdPergunta, setCampoIdPergunta]   = useState("");
    var [campoDescricao, setCampoDescricao]   = useState("");
    var [campoPergunta, setCampoPergunta]   = useState({value: "", label: "Selecione..."});
    var [campoObrigatorio, setCampoObrigatorio]   = useState({value: "N", text: "NÃO"});
    var [campoHabilitadoPreenchimento, setCampoHabilitadoPreenchimento]   = useState({value: "N", text: "NÃO"});
    var [dataQuestionario, setDataQuestionario]   = useState([]);

    useEffect(() => {
        if (idEtapa){
            setInclusao(false)
            loadEtapa();
        }
    }, []);

    // Processa consulta do grid
    const loadEtapa = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaAPI( consultaEtapa );
        
        if (retConsulta.data){
            setCampoDescricao(retConsulta.data[0].Descricao);
            var retFormulario = await ConsultaAPI( consultaFormulario );
            
            if (retFormulario.data){
                let dados = retFormulario.data

                let dadosQuestionario = dados.map( (formulario) => {
                    return {    descricao: formulario.Descricao, 
                                pergunta: formulario.Pergunta, 
                                obrigatorio: formulario.Obrigatorio, 
                                habilitado: formulario.HabilitadoPreenchimento,
                                deletado: false, 
                                id: formulario.Id
                    }
                })

                setDataQuestionario(dadosQuestionario);
            }
        }
        
        setCarregar(false);
    }

    const handleAlterarQuestionario = (row) => {
        const obrigatorio = row.original.obrigatorio || 'S'
        const HabilitadoPreenchimento = row.original.HabilitadoPreenchimento || 'S'
        setCampoIdPergunta(row.original.id)
        setCampoObrigatorio({value: obrigatorio, text: obrigatorio == "S" ? "SIM" : "NÃO"})
        setCampoHabilitadoPreenchimento({value: HabilitadoPreenchimento, text: HabilitadoPreenchimento == "S" ? "SIM" : "NÃO"})
        setCampoPergunta({value: row.original.pergunta, label: row.original.descricao})
    }

    const btnIncluirQuestionario = () => {
        if (campoPergunta.value === ""){
            toast.warning('Obrigatório escolher uma Pergunta.');
            return;
        }
        
        let pergunta = campoPergunta.value
        let isObrigatorio = campoObrigatorio.value || 'N'
        let isHabilitadoPreenchimento = campoHabilitadoPreenchimento.value || 'N'
        let descricao = campoPergunta.label

        if (campoIdPergunta){
            const id = campoIdPergunta
            
            setDataQuestionario((prevData) => {
                return prevData.map((item) => {
                    if (item.id === id){
                        return { ...item, 
                            descricao: descricao, 
                            pergunta: pergunta, 
                            obrigatorio: isObrigatorio,
                            habilitado: isHabilitadoPreenchimento
                         };
                    }else{
                        return item;
                    } 
                })
            });
        }else{
            const newId = Date.now()
            setDataQuestionario((prevData) => [...prevData, { 
                descricao: descricao, 
                pergunta: pergunta, 
                obrigatorio: isObrigatorio, 
                habilitado: isHabilitadoPreenchimento, 
                deletado: false, 
                id: 'NEW' + newId
            }]);
        }

        btnCancelarQuestionario()
    };

    const btnCancelarQuestionario = () => {
        setCampoIdPergunta("")
        setCampoPergunta({value: "", label: "Selecione..."})
        setCampoObrigatorio({value: "N", text: "NÃO"})
        setCampoHabilitadoPreenchimento({value: "S", text: "SIM"})
    }

    const handleExcluirQuestionario = (row) => {
        const deletar = row.original.id;
        let dados = [...dataQuestionario]
        dados.forEach((item) => { 
            if (item.id == deletar){ 
                item.deletado = true 
            } 
            return item 
        })

        const newData = dados;
        setDataQuestionario(newData);        
    };

    const handleSalvar = async() =>{
        // Verificar se todos os campos obrigatórios foram preenchidos
        if (!campoDescricao) {
            toast.warning('O prenchimento do campo é obrigatório.');
            return false;
        }

        try {
            setCarregar(true);
            const rota = 'etapas' + (inclusao ? '' : '/' + idEtapa);
            
            const perguntasDados = dataQuestionario.map( (item) => {
                if (typeof item.id == 'string'){
                    item.id = 0;      
                }

                return item
            }) 

            let jsonSalvar = {
                descricao: campoDescricao,
                perguntas: perguntasDados
            }

            const retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, jsonSalvar)
                : ConsumoAPI_PUT(rota, jsonSalvar));
    
            SucessoMsg(retConsumo.description);
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Etapa"/>
            </Col>
            <Col md="12" xs="12">
                <InputGeral 
                    label="Descrição"
                    tipo='text'
                    value={campoDescricao}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoDescricao(e.target.value)}
                />
            </Col>
        </Row>
        <HRDivider/>
            <Row>
                <Col md="10" xs="12">
                    <h5>Perguntas da Etapa: </h5>
                </Col>
            </Row>
        <Row>
            <Col md="5" xs="12">
                <SelectDinamico 
                    label="Perguntas"
                    consulta={ConsultaPergunta.consulta}
                    tabela={ConsultaPergunta.tabelas}
                    cValue="Id"
                    cText='Id + " - " + item.Descricao'
                    isMultiplo={false}
                    value={campoPergunta}
                    campoValue={campoPergunta}
                    onchange={(e) => setCampoPergunta(e)}
                    showNoFilter={false}
                />
            </Col>
            <Col md="2" xs="12">
                <SelectFixo 
                    options={[
                        {
                            value: 'S',
                            text: "SIM",
                        },
                        {
                            value: 'N',
                            text: "NÃO",
                        }
                    ]} 
                    value={campoObrigatorio} 
                    selectedOptionValue={campoObrigatorio} 
                    isLabel={true} 
                    label="Obrigatório" 
                    onChange={(e) => setCampoObrigatorio(e)}
                />
            </Col>
            <Col md="2" xs="12">
                <SelectFixo 
                    options={[
                        {
                            value: 'S',
                            text: "SIM",
                        },
                        {
                            value: 'N',
                            text: "NÃO",
                        }
                    ]} 
                    value={campoHabilitadoPreenchimento} 
                    selectedOptionValue={campoHabilitadoPreenchimento} 
                    isLabel={true} 
                    label="Habilita Preenchimento" 
                    onChange={(e) => setCampoHabilitadoPreenchimento(e)}
                />
            </Col>
            <Col md="3" xs="12" className="d-flex align-content-end align-items-end justify-content-end">
                <Button variant="primary" onClick={btnIncluirQuestionario}> { !campoIdPergunta ? '🞧 Adicionar' : '✓ Salvar' }</Button>
                <CancelarButton variant="danger" onClick={btnCancelarQuestionario}>✗ Cancelar</CancelarButton>
            </Col>
        </Row>

        {dataQuestionario && dataQuestionario.length > 0 && (
            <ResponsiveDataTable 
                habilitaBuscar={false} 
                columns={[
                    {
                        Header: 'Perguntas',
                        accessor: 'descricao',
                    },
                    {
                        Header: 'Obrigatório',
                        accessor: 'obrigatorio',
                        Cell: handleSimNao
                    },
                    {
                        Header: 'Habilitado Preenchimento',
                        accessor: 'habilitado',
                        Cell: handleSimNao
                    }
                ]} 
                data={dataQuestionario.filter( item => item.deletado === false)} 
                isIgnorar={true}
                buttons= { campoIdPergunta ? [] : [
                    { action: handleAlterarQuestionario, label: "Alterar", icone: "MdOutlineEditNote", },
                    { action: handleExcluirQuestionario, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", }
                ]}
            />
        )}
        
        <SubmitForm onSave={handleSalvar} onCancel={"handleCancelar"}></SubmitForm>
        </>
    );
}

export default FichaEtapa;